import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendDuoPush } from 'services/pod';
import { ISendPushNotificationPayload } from 'services/pod/types';

export const ThunkSendDuoPush = createAsyncThunk(
  'pod/sendDuoPush',
  async (payload: ISendPushNotificationPayload) => sendDuoPush(payload).then(res => res.data),
);
